/**
 * 客服聊天 Store
 * @description 存储客服信息、会话状态和弹框控制
 */
import { defineStore } from 'pinia'

export interface CustomerServiceInfo {
  id: number
  uid: number
  nickName: string
  avatar: string
  postTitleName: string
  workTime: string
  phone: string
  wechat: string
  welcomeMessage: string
  skillList: any[]
  isOnline: boolean
}

export interface ConversationInfo {
  id: number
  customerId: number
  customerServiceId: number
  channelId?: string | number
  status: number
  createTime: string
  updateTime: string
  userUnReadMessageCount?: number
}

// 会话列表项
export interface SessionItem {
  id: number
  userId: number
  customerServiceId: number
  selectServiveId: number
  firstMessageTime: string
  lastMessageTime: string
  lastMessage: string
  userMessageCount: number
  serviceMessageCount: number
  isServiceReplied: number
  isCustomerRead: number
  status: number
  createTime: string
  updateTime: string
  channelId: string
  channelType: number
  userInfo: any
  customerServiceInfo: any
  userUnReadMessageCount: number
  serviceUnReadMessageCount: number
}

interface CustomerServiceState {
  customerServiceInfo: CustomerServiceInfo | null
  conversationInfo: ConversationInfo | null
  isPopupVisible: boolean // 控制弹框显示
  selectServiveId: string | number | null // 当前选择的客服id，用于跟会话列表匹配
  isServiceOnline: boolean//是否显示客服浮框
  sessionList: SessionItem[] // 会话列表
  currentSessionId: number | null // 当前选中的会话ID
}

export const useCustomerServiceStore = defineStore('customerService', {
  state: (): CustomerServiceState => ({
    customerServiceInfo: null,
    conversationInfo: null,
    isPopupVisible: false,
    selectServiveId: null,
    isServiceOnline: false,
    sessionList: [],
    currentSessionId: null
  }),

  getters: {
    // 弹框是否显示
    isVisible: (state): boolean => {
      return state.isPopupVisible
    },
  },

  actions: {
    // 设置客服信息
    setCustomerServiceInfo(data: CustomerServiceInfo | null) {
      this.customerServiceInfo = data
    },

    // 设置会话信息
    setConversationInfo(data: ConversationInfo | null) {
      this.conversationInfo = data
    },

    // 设置会话列表
    setSessionList(list: SessionItem[]) {
      this.sessionList = list
    },

    // 设置当前选中的会话ID
    setCurrentSessionId(sessionId: number | null) {
      this.currentSessionId = sessionId
    },

    // 打开客服弹框
    openPopup(selectServiveId?: string | number) {
      if (selectServiveId) {
        this.selectServiveId = selectServiveId
      }else{
        this.selectServiveId = null //如果没有选择客服，则不需要与会话列表匹配，默认第一个会话
      }
      this.isPopupVisible = true
      this.isServiceOnline = true
      localStorage.setItem('isServiceFloat', 'true')
    },

    // 关闭客服弹框
    closePopup() {
      this.isPopupVisible = false
    },

    // 切换弹框显示状态
    togglePopup() {
      this.isPopupVisible = !this.isPopupVisible
    },

    // 清除客服浮框状态
    clearServiceFloat() {
      this.isServiceOnline = false
      localStorage.removeItem('isServiceFloat')
    },

    // 从 localStorage 初始化浮框状态
    initServiceFloatFromStorage() {
      const isServiceFloat = localStorage.getItem('isServiceFloat')
      if (isServiceFloat === 'true') {
        this.isServiceOnline = true
      }
    },

    // 重置所有状态
    reset() {
      this.customerServiceInfo = null
      this.conversationInfo = null
      this.isPopupVisible = false
      this.selectServiveId = null
      this.sessionList = []
      this.currentSessionId = null
    },
  },
})
